<template>
  <div>
    <el-drawer
      :visible="visible"
      size="60%"
      destroy-on-close
      :wrapperClosable="false"
      custom-class="in-out-stock-form"
      @close="handleClose(false)"
    >
      <template slot="title">
        <span>{{
          stockOrder.StockStatus == 2 ? title + ' - 详情' : (formView.isSaleReturn || stockOrder.ID ? '编辑 - ' : '新增 - ') + title
        }}</span>
      </template>
      <div v-if="formView.isScanMode" style="text-align: center">
        <el-input
          ref="scanInput"
          v-model="scanBarcode"
          class="scan-barcode-input"
          placeholder="扫码/手动输入条码"
          style="width: 80%; margin-top: 8px; margin-bottom: 8px"
          clearable
          @keyup.enter.native="handleScanBarcode"
        />
      </div>
          <!-- 新增提示行 -->
    <div v-if="formView.isScanMode" style="text-align: center; margin-bottom: 16px">
      <span style="color: red; font-size: 12px">
        <i class="el-icon-warning-outline" style="margin-right: 4px"></i>
        提示：扫码前请切换英文输入法，否则条码无法正常识别
      </span>
    </div>
      <el-container v-if="stockOrder.StockType">
        <el-header>
          <el-form :inline="true" label-suffix="：">
            <el-form-item v-if="formView.isPurchaseType" prop="SupplierName" label="供应商">
              <el-autocomplete
                v-if="stockOrder.StockStatus == 0"
                placeholder="请输入供应商"
                v-model.trim="stockOrder.SupplierName"
                value-key="SupplierName"
                style="width: 120px"
                :fetch-suggestions="handleFilterSuppliers"
                @select="handleSelectSupplier"
              />
              <span v-else>{{ stockOrder.SupplierName }}，</span>
            </el-form-item>
            <el-form-item v-if="$store.state.routes.systemSetting.MultiWarehouse" label="仓库">
              <warehouse-select
                v-if="stockOrder.StockStatus == 0"
                :value.sync="stockOrder.WID"
                select_style="width:120px;"
                :set_default="true"
                @handleChanged="handleChangeWarehouse"
              />
              <span v-else>
                {{ stockOrder.WName || '默认仓库' }}
              </span>
            </el-form-item>
            <el-form-item v-if="!formView.isSaleReturn && !stockOrder.ID && !formView.isScanMode">
              <el-button type="primary" @click="handleAddGoodsShow">新增商品</el-button>
            </el-form-item>
            <el-form-item class="stats">
              <template v-if="formView.isSaleReturn">
                退货日期：
                <span class="return-date">{{ returnOrder.returnDate }}</span>
                ，
              </template>
              <span>
                货号合计：
                <span class="quantity">{{ formView.TotalItemNum }}</span>
                个，
              </span>
              <span v-if="formView.isSaleReturn">
                退货合计：
                <span class="quantity"> {{ formView.Quantity }} </span>
                件，
              </span>
              <span v-else-if="formView.isPurchaseType">
                {{ formView.purchaseTypeDesc }}数量：
                <span class="quantity"> {{ formView.Quantity }} </span>
                件，
              </span>
              <span v-if="formView.isPurchaseType && stockOrder.StockStatus == 1">
                已{{ stockOrder.orderType == 1 ? '入' : '出' }}数量：
                <span class="quantity">{{ formView.DoneQuantity }}</span>
                件，
              </span>
              <span>
                {{ formView.isPurchaseType && stockOrder.StockStatus != 2 ? '本次' : '' }}{{ formView.stockTypeDesc }}数量：
                <span class="quantity">{{ formView.ActualQuantity }}</span>
                件
              </span>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main>
          <grid-table
            ref="detailTable"
            class="detail-table"
            :showCheckboxColumn="false"
            :showPagination="false"
            :showLastEmptyColumn="false"
            :tableConfig="tableConfig"
            :loading="loading"
            @handleQuantityDisable="handleQuantityDisable"
            @handleActualQuantityDisable="handleActualQuantityDisable"
            @handleInputChange="handleRowInputChanged"
          >
            <template slot="QuantityHeader" slot-scope="{}">
              <span>{{ formView.purchaseTypeDesc }}数量</span>
              <el-tooltip v-if="stockOrder.StockStatus == 0" :content="`批量设置${formView.purchaseTypeDesc}数量`" placement="top-start">
                <el-input-number
                  v-model="batchSetQuantity"
                  class="header-action"
                  :controls="false"
                  :min="0"
                  @change="handleBatchSetQuantity"
                />
              </el-tooltip>
            </template>
            <template slot="SaleReturnQuantity" slot-scope="{ params }">
              {{ params.row.Quantity }}
              <span
                v-if="stockOrder.StockStatus == 0 && calcNoMatchCount(params.row.ProductID) > 0"
                class="wait-match"
                title="点击去分配"
                @click="handleMatchProduct(params.row)"
              >
                （待分配：{{ calcNoMatchCount(params.row.ProductID) }}）
              </span>
              <span v-else-if="stockOrder.StockStatus == 0" class="match-done">
                （待分配：{{ calcNoMatchCount(params.row.ProductID) }}）
              </span>
            </template>
            <template slot="DoneQuantityHeader" slot-scope="{}">
              <span>已{{ stockOrder.StockType == 1 ? '入' : '出' }}数量</span>
            </template>
            <template slot="ActualQuantityHeader" slot-scope="{}">
              {{ formView.stockTypeDesc }}数量
              <template v-if="stockOrder.StockStatus < 2">
                <el-tooltip
                  v-if="!formView.isSaleReturn && !formView.isPurchaseType"
                  :content="`批量设置${formView.purchaseTypeDesc}数量`"
                  placement="top-start"
                >
                  <el-input-number
                    v-model="batchSetActualQuantity"
                    class="header-action"
                    :controls="false"
                    :min="0"
                    @change="handleBatchSetActualQuantity"
                  />
                </el-tooltip>
                <el-button v-else type="primary" plain class="header-action" size="mini" @click="handleSyncQuantity">
                  全部{{ formView.stockTypeDesc }}
                </el-button>
              </template>
            </template>
            <template v-if="!formView.isSaleReturn && stockOrder.StockStatus == 0" slot="operation" slot-scope="{ params }">
              <i class="el-icon-delete" @click="handelDeleteRow(params.row, params.row.index)" />
            </template>
          </grid-table>
        </el-main>
        <el-footer>
          <el-button type="default" @click="handleClose(false)">关闭</el-button>
          <el-button type="primary" plain @click="handleCopy">复制报单</el-button>
          <template v-if="formView.isPurchaseType">
            <el-button v-if="stockOrder.ID && stockOrder.StockStatus == 0" type="danger" :loading="submitLoading" @click="handleDelete">
              删除
            </el-button>
            <el-button v-if="!stockOrder.ID" type="success" :loading="submitLoading" @click="handleSave()"> 保存单据 </el-button>
            <el-button type="warning" v-if="stockOrder.StockStatus < 2" :loading="submitLoading" @click="handleOperateStock()">
              部分{{ formView.stockTypeDesc }}
            </el-button>
            <el-button type="primary" v-if="stockOrder.StockStatus < 2" :loading="submitLoading" @click="handleOperateStock(true)">
              完成{{ formView.stockTypeDesc }}
            </el-button>
          </template>
          <el-button type="primary" v-else-if="stockOrder.StockStatus == 0" :loading="submitLoading" @click="handleOperateStock(true)">
            确认{{ formView.stockTypeDesc }}
          </el-button>
        </el-footer>
      </el-container>
      <add-goods ref="addGoods" @handleSave="handleAddGoods" />
    </el-drawer>
    <el-dialog title="选择退货日期" :visible.sync="returnOrder.visible" width="400px" :close-on-click-modal="false" append-to-body>
      <div style="text-align: center">
        <el-date-picker
          v-model="returnOrder.returnDate"
          type="date"
          placeholder="选择退货日期"
          value-format="yyyy-MM-dd"
          :editable="false"
          :clearable="false"
          style="width: 200px"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnOrder.visible = false">取消</el-button>
        <el-button type="primary" :loading="returnOrder.loading" @click="handleConfirmReturnDate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { submit } from '@/api/base'
import AddGoods from '@/views/wms/stock/components/AddGoods.vue'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
import clipboard from '@/utils/clipboard'
import dayjs from 'dayjs'

export default {
  name: 'InOutStockForm',
  components: {
    WarehouseSelect,
    AddGoods,
  },
  data() {
    return {
      visible: false,
      title: '',
      suppliers: [],
      formView: {},
      initFormView: {
        stockTypeDesc: '',
        isPurchaseType: false,
        purchaseTypeDesc: '',
        isSaleReturn: false,
        isScanMode: false, //是否为扫码模式
        detailType: undefined, //场景：1手动入库，2手动出库，3销售退货，7采购入库，8采购退货
        Quantity: 0,
        DoneQuantity: 0,
        ActualQuantity: 0,
        TotalItemNum: 0,
      },
      stockOrder: {},
      initStockOrder: {
        ID: 0,
        StockType: 1, //出入库类型：1入库，2出库
        OrderType: 3, //订单类型：1采购，2退货，3手动
        StockStatus: 0,
        SupplierID: 0,
        SupplierName: '',
        WID: 0,
        WName: '',
        DetailList: [],
      },
      returnOrder: {
        visible: false, //退货日期选择框
        returnDate: '', //选择的退货日期
        loading: false,
        noMatchProduct: {},
        refundIDs: [],
      },
      loading: false,
      batchSetQuantity: undefined,
      batchSetActualQuantity: undefined,
      submitLoading: false,
      scanBarcode: '',
      scanLoading: false,
    }
  },
  computed: {
    tableConfig() {
      return {
        columns: [
          {
            label: '货号',
            prop: 'ItemNo',
            type: 'text',
            filter: true,
          },
          {
            label: '颜色',
            prop: 'Color',
            type: 'text',
            width: '220',
            filter: true,
          },
          {
            label: '尺码',
            prop: 'Size',
            type: 'text',
            width: '220',
            filter: true,
          },
          {
            label: '采 / 退数量',
            prop: 'Quantity',
            headerCustom: true,
            type: 'input-int',
            width: '200',
            method: 'handleInputChange',
            checkDisableMethod: 'handleQuantityDisable',
            isHidden: !this.formView.isPurchaseType || this.formView.isScanMode,
          },
          {
            label: '退货数量',
            prop: 'SaleReturnQuantity',
            type: 'custom-operation',
            width: '180',
            isHidden: !this.formView.isSaleReturn,
          },
          {
            label: '已出/入数量',
            prop: 'DoneQuantity',
            headerCustom: true,
            type: 'text',
            width: '180',
            isHidden: !(this.formView.isPurchaseType && this.stockOrder.StockStatus == 1),
          },
          {
            label: '出/入库数量',
            prop: 'ActualQuantity',
            headerCustom: true,
            type: 'input-int',
            width: '200',
            method: 'handleInputChange',
            checkDisableMethod: 'handleActualQuantityDisable',
          },
          {
            label: '供应商',
            prop: 'SupplierName',
            type: 'text',
            width: '180',
            isHidden: !this.formView.isSaleReturn,
          },
          {
            label: '操作',
            prop: 'operation',
            type: 'custom-operation',
            width: '100',
            isHidden: this.formView.isSaleReturn || this.stockOrder.StockStatus != 0,
          },
        ],
      }
    },
  },
  mounted() {
    this.init()
    this.returnOrder.returnDate = dayjs().add(-1, 'day').format('YYYY-MM-DD')
  },
  methods: {
    //初始化
    init() {
      this.formView = JSON.parse(JSON.stringify(this.initFormView))
      this.stockOrder = JSON.parse(JSON.stringify(this.initStockOrder))
    },
    //显示
    async show(stockType, orderType, id = null) {
      let data = null
      if (id) {
        const res = await submit('/api/wms/stock/getStockOrderDetail', { orderID: id })
        data = res.data
        Object.assign(this.stockOrder, this._.pick(data.main, Object.keys(this.stockOrder)))
        let quantity = 0
        let doneQuantity = 0
        let actualQuantity = 0
        data.details.forEach(item => {
          item.DoneQuantity = item.ActualQuantity
          if (this.stockOrder.StockStatus < 2) {
            item.ActualQuantity = undefined
          } else {
            actualQuantity += item.ActualQuantity
          }
          quantity += item.Quantity
          doneQuantity += item.DoneQuantity
        })
        this.formView.Quantity = quantity
        this.formView.TotalItemNum = data.totalItemNum
        this.formView.DoneQuantity = doneQuantity
        this.formView.ActualQuantity = actualQuantity
      } else {
        this.stockOrder.StockType = stockType == 'in' ? 1 : 2
        this.stockOrder.OrderType = orderType == 'purchase' ? 1 : orderType == 'return' ? 2 : 3
        this.formView.isScanMode = orderType == 'scan'
      }
      if (this.stockOrder.StockType == 1) {
        this.formView.stockTypeDesc = '入库'
        this.formView.detailType = { 1: 7, 2: 3, 3: 1 }[this.stockOrder.OrderType] || undefined
      } else {
        this.formView.stockTypeDesc = '出库'
        this.formView.detailType = { 1: 8, 3: 2 }[this.stockOrder.OrderType] || undefined
      }
      if (!this.formView.detailType) {
        this.$message.error('单据类型异常')
        return
      }
      this.title = { 1: '手动入库', 2: '手动出库', 3: '销售退货', 7: '采购入库', 8: '采购退货' }[this.formView.detailType] || '未知类型'
      this.formView.isPurchaseType = [7, 8].includes(this.formView.detailType)
      this.formView.purchaseTypeDesc = this.formView.isPurchaseType ? (this.stockOrder.StockType == 1 ? '采购' : '退货') : ''
      this.formView.isSaleReturn = this.formView.detailType == 3
      if (this.formView.isPurchaseType && this.stockOrder.StockStatus == 0) {
        this.fetchSuppliers()
      }
      if (this.formView.isSaleReturn && !this.stockOrder.ID) {
        this.returnOrder.visible = true
      } else {
        if (this.formView.isSaleReturn && this.stockOrder.StockStatus == 2) {
          this.returnOrder.returnDate = dayjs(data.main.SourceOrderTime).format('YYYY-MM-DD')
        }
        this.visible = true
        this.$nextTick(() => {
          this.$refs.detailTable.setData(this.stockOrder.ID ? data?.details ?? [] : [])
          if (!this.stockOrder.ID) {
            if (this.formView.isScanMode) {
              this.scanBarcode = ''
              this.$refs.scanInput?.focus()
            } else {
              this.handleAddGoodsShow()
            }
          }
        })
      }
    },
    //加载供应商
    async fetchSuppliers() {
      const { data } = await submit('/api/purchase/supplier/getList', {
        CurrentPage: 1,
        PageSize: 1000,
      })
      this.suppliers = data.datas || []
    },
    //选择退货日期
    async handleConfirmReturnDate() {
      if (!this.returnOrder.returnDate) {
        this.$message.error('请选择退货日期')
        return
      }
      try {
        this.returnOrder.loading = true
        const res = await submit('/api/wms/stock/getReturnDetails', {
          RefundDate: this.returnOrder.returnDate,
        })
        if (!res.success || (res.data.Details || []).length == 0) {
          this.$message.error('没有可退货的退货单')
          return
        }
        this.stockOrder.WName = res.data.WName
        this.returnOrder.noMatchProduct = {}
        this.returnOrder.refundIDs = res.data.RefundIDs
        this.formView.Quantity = res.data.TotalCount
        let itemNos = []
        let actualQuantity = 0
        res.data.Details.forEach(item => {
          itemNos.push(item.ItemNo)
          if (!(item.ProductID in this.returnOrder.noMatchProduct)) {
            this.returnOrder.noMatchProduct[item.ProductID] = 0
          }
          if (!item.SpecID) {
            this.returnOrder.noMatchProduct[item.ProductID] += item.Num
            item.Quantity = 0
            item.ActualQuantity = undefined
          } else {
            item.Quantity = item.Num
            item.ActualQuantity = item.Num
            actualQuantity += item.Num
          }
        })
        this.formView.TotalItemNum = new Set(itemNos).size
        this.formView.ActualQuantity = actualQuantity
        this.returnOrder.visible = false
        this.visible = true
        this.$nextTick(() => {
          this.$refs.detailTable.setData(res.data.Details)
        })
      } catch (error) {
        this.$message.error('未获取到' + this.this.selectedReturnDate + '的退货数据')
      } finally {
        this.returnOrder.loading = false
      }
    },
    calcNoMatchCount(productId) {
      return this.returnOrder.noMatchProduct[productId] || 0
    },
    handleMatchProduct(row) {
      this.$refs.addGoods.init(false, '分配', row.ItemNo, undefined, true, this.calcNoMatchCount(row.ProductID))
    },
    //筛选供应商
    async handleFilterSuppliers(qs, cb) {
      const suppliers = this.suppliers
      var results = qs ? suppliers.filter(t => t.SupplierName.toLowerCase().includes(qs.toLowerCase())) : suppliers
      cb(
        results.map(item => ({
          ID: item.SupplierID,
          SupplierName: item.SupplierName,
        })) || []
      )
    },
    //选择供应商
    handleSelectSupplier(data) {
      this.stockOrder.SupplierID = data.ID
      this.stockOrder.SupplierName = data.SupplierName
    },
    //变更仓库
    handleChangeWarehouse(data) {
      this.stockOrder.WID = data.WID || 0
      this.stockOrder.WName = data.WName || ''
    },
    handleQuantityDisable(row, callback) {
      callback(this.stockOrder.ID ? true : false)
    },
    handleActualQuantityDisable(row, callback) {
      callback(this.stockOrder.StockStatus >= 2)
    },
    //新增商品
    handleAddGoodsShow() {
      this.$refs.addGoods.init(false, this.title + ' - 新增商品', undefined, this.stockOrder.WID)
    },
    handleAddGoods(data) {
      if (!this.formView.isSaleReturn) {
        this.addGoods(data)
      } else {
        this.addReturnGoods(data)
      }
    },
    addGoods(data) {
      if (!this.$refs.detailTable.tableData.some(row => row.ProductID == data.ProductID)) {
        this.formView.TotalItemNum += 1
      }
      let addQuantity = 0
      let addActualQuantity = 0
      for (let key in data.Colors) {
        for (let sku of data.Colors[key].Details) {
          const existSku = this.$refs.detailTable.tableData.some(
            row => row.ProductID == sku.ProductID && row.Color == sku.Color && row.Size == sku.Size
          )
          if (!existSku) {
            let newRow = {
              DetailID: 0,
              ID: this.stockOrder.ID,
              ProductID: sku.ProductID,
              ItemNo: data.ItemNo,
              SpecID: sku.SpecID,
              SpecName: sku.Color + '-' + sku.Size,
              Color: sku.Color,
              Size: sku.Size,
              Quantity: sku.Num && sku.Num > 0 ? sku.Num : undefined,
              DoneQuantity: 0,
            }
            newRow.ActualQuantity = !this.formView.isPurchaseType ? newRow.Quantity : undefined
            this.$refs.detailTable.tableData.push(newRow)
            this.$refs.detailTable.setRow(this.$refs.detailTable.tableData.length - 1)
            addQuantity += newRow.Quantity || 0
            addActualQuantity += newRow.ActualQuantity || 0
          }
        }
      }
      this.formView.Quantity += addQuantity
      this.formView.ActualQuantity += addActualQuantity
    },
    addReturnGoods(data) {
      var noMatchCount = this.calcNoMatchCount(data.ProductID)
      if (noMatchCount <= 0) {
        this.$message('货号' + data.ItemNo + '没有待分配的商品')
        return
      }
      var list = this.$refs.detailTable.tableData
      let addActualQuantity = 0
      for (let key in data.Colors) {
        for (let sku of data.Colors[key].Details) {
          if (sku.Num <= 0) {
            continue
          }
          const existSku = this.$refs.detailTable.tableData.some(row => row.ProductID == sku.ProductID && row.SpecID == sku.SpecID)
          if (!existSku) {
            list.push({
              DetailID: 0,
              ID: this.stockOrder.ID,
              ProductID: sku.ProductID,
              ItemNo: data.ItemNo,
              SpecID: sku.SpecID,
              SpecName: sku.Color + '-' + sku.Size,
              Color: sku.Color,
              Size: sku.Size,
              Quantity: sku.Num || 0,
              ActualQuantity: sku.Num || 0,
              SupplierID: data.DefaultSupplier,
              SupplierName: data.DefaultSupplierName,
            })
            this.returnOrder.noMatchProduct[sku.ProductID] -= sku.Num
            addActualQuantity += sku.Num || 0
          }
        }
      }
      this.formView.ActualQuantity += addActualQuantity
      list = list.filter(row => row.ProductID != data.ProductID || (row.ProductID == data.ProductID && row.Color))
      list = list.sort(function (a, b) {
        if (a.ProductID !== b.ProductID) return a.ProductID < b.ProductID ? -1 : 1
        else if (a.Color !== b.Color) return a.Color < b.Color ? -1 : 1
        else if (a.Size !== b.Size) return a.Size < b.Size ? -1 : 1
      })
      this.$refs.detailTable.setData(list)
    },
    //批量设置数量
    handleBatchSetQuantity() {
      const setQuantity = !this.batchSetQuantity || this.batchSetQuantity < 0 ? undefined : this.batchSetQuantity
      let quantity = 0
      this.$refs.detailTable.tableData.forEach(row => {
        row.Quantity = setQuantity
        quantity += row.Quantity || 0
      })
      this.formView.Quantity = quantity
    },
    //批量设置出/入库数量
    handleBatchSetActualQuantity() {
      const setActualQuantity = !this.batchSetActualQuantity || this.batchSetActualQuantity < 0 ? undefined : this.batchSetActualQuantity
      let actualQuantity = 0
      this.$refs.detailTable.tableData.forEach(row => {
        row.ActualQuantity = setActualQuantity
        actualQuantity += row.ActualQuantity || 0
      })
      this.formView.ActualQuantity = actualQuantity
    },
    //全部出/入库
    handleSyncQuantity() {
      let actualQuantity = 0
      this.$refs.detailTable.tableData.forEach(row => {
        row.ActualQuantity = row.Quantity && row.Quantity >= 0 ? row.Quantity - (row.DoneQuantity || 0) : undefined
        actualQuantity += row.ActualQuantity || 0
      })
      this.formView.ActualQuantity = actualQuantity
    },
    //变更行输入
    handleRowInputChanged(rowIndex, value, prop) {
      this.$nextTick(() => {
        let row = this.$refs.detailTable.tableData[rowIndex]
        if (this.formView.isSaleReturn) {
          if (!row.SpecID) {
            this.$message.error('存在未分配的商品，请分配到具体规格再修改')
            this.$set(row, prop, 0)
            return
          }
          if (!value || value < 0) {
            this.returnOrder.noMatchProduct[row.ProductID] += row.Quantity
            if (
              this.$refs.detailTable.tableData.some(item => item.ProductID == row.ProductID && item.SpecID && item.SpecID != row.SpecID)
            ) {
              this.$refs.detailTable.tableData.splice(rowIndex, 1)
            } else {
              this.$set(this.$refs.detailTable.tableData, rowIndex, {
                ...row,
                Quantity: 0,
                ActualQuantity: 0,
                SpecID: 0,
                Color: '',
                Size: '',
                SpecName: '',
              })
              this.handleMatchProduct(row)
            }
          } else if (value > row.Quantity) {
            const validCount = row.Quantity + this.returnOrder.noMatchProduct[row.ProductID]
            if (value > validCount) {
              this.returnOrder.noMatchProduct[row.ProductID] = 0
              this.$set(this.$refs.detailTable.tableData, rowIndex, { ...row, Quantity: validCount, ActualQuantity: validCount })
            } else {
              this.returnOrder.noMatchProduct[row.ProductID] -= value - row.Quantity
              this.$set(row, 'Quantity', value)
            }
          } else if (value < row.Quantity) {
            this.returnOrder.noMatchProduct[row.ProductID] += row.Quantity - value
            this.$set(row, 'Quantity', value)
          }
        }
        if (!this.formView.isSaleReturn || prop == 'ActualQuantity') {
          this.formView[prop] = this.$refs.detailTable.tableData.reduce((total, item) => {
            return total + (item[prop] || 0)
          }, 0)
        }
        this.returnOrder.noMatchProduct = { ...this.returnOrder.noMatchProduct }
        this.$forceUpdate()
      })
    },
    //删除行
    handelDeleteRow(row, index) {
      this.$refs.detailTable.tableData.splice(index, 1)
      let hasSameItemNo = false
      let quantity = 0
      let actualQuantity = 0
      this.$refs.detailTable.tableData.forEach(tableRow => {
        if (tableRow.ItemNo == row.ItemNo) {
          hasSameItemNo = true
        }
        quantity += tableRow.Quantity || 0
        actualQuantity += tableRow.ActualQuantity || 0
      })
      if (!hasSameItemNo) {
        this.formView.TotalItemNum--
      }
      this.formView.Quantity = quantity
      this.formView.ActualQuantity = actualQuantity
    },
    //关闭
    handleClose(refresh = true) {
      this.visible = false
      this.scanBarcode = ''
      this.scanLoading = false
      this.init()
      if (refresh) {
        this.$emit('refresh')
      }
    },
    //复制报单
    handleCopy(e) {
      if (this.$refs.detailTable.tableData.length == 0) {
        this.$message.error('没有可复制的商品')
        return
      }
      let copyObj = {}
      this.$refs.detailTable.tableData.forEach(row => {
        if (row.Quantity && row.Quantity > 0) {
          if (!(row.ItemNo in copyObj)) {
            copyObj[row.ItemNo] = {}
          }
          if (!(row.Color in copyObj[row.ItemNo])) {
            copyObj[row.ItemNo][row.Color] = []
          }
          copyObj[row.ItemNo][row.Color].push(row.Size + '*' + row.Quantity)
        }
      })
      let text = ''
      for (let itemNo in copyObj) {
        let specText = ''
        for (let color in copyObj[itemNo]) {
          specText += color
          for (let size of copyObj[itemNo][color]) {
            specText += size + ' '
          }
        }
        text += itemNo + specText + '\r\n'
      }
      if (!text) {
        this.$message.error(`没有可复制的商品，请${this.formView.isSaleReturn ? '退货' : '商品'}数量大于0`)
      } else {
        clipboard(text, e)
      }
    },
    //删除报单
    handleDelete() {
      if (!this.stockOrder.ID) {
        return
      }
      const _this = this
      this.$confirm(`确定删除当前${this.formView.stockTypeDesc}单？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          _this.submitLoading = true
          const res = await submit('/api/wms/stock/deleteStockOrder', { orderID: _this.stockOrder.ID })
          _this.submitLoading = false
          if (res.success) {
            _this.$message.success('删除成功')
            _this.handleClose()
          } else {
            _this.$message.error(res.msg)
          }
        })
        .catch(() => {
          _this.$message.error('删除失败')
        })
    },
    //保存
    async handleSave(onlySave = true) {
      if (this.formView.isPurchaseType && !this.stockOrder.SupplierName) {
        this.$message.error('请输入供应商')
        return false
      }
      if (this.$refs.detailTable.tableData.length <= 0) {
        this.$message.error('商品不能为空')
        return false
      }
      if (this.formView.isPurchaseType) {
        let index = 1
        for (let row of this.$refs.detailTable.tableData) {
          if (!row.Quantity || row.Quantity <= 0) {
            this.$message.error(`第${index}行${this.formView.purchaseTypeDesc}数量不能为0`)
            return
          }
          index++
        }
      }
      this.stockOrder.DetailList = this.$refs.detailTable.tableData.map(row => ({
        ProductID: row.ProductID,
        ItemNo: row.ItemNo,
        SpecID: row.SpecID,
        SpecName: row.SpecName,
        Quantity: row.Quantity,
      }))
      this.submitLoading = true
      const { data } = await submit('/api/wms/stock/saveStockOrder', this.stockOrder)
      this.submitLoading = false
      if (data.errorMsg) {
        this.$message.error(data.errorMsg)
        return false
      }
      this.stockOrder.ID = data.ID
      if (onlySave) {
        this.$message.success('保存成功')
        this.handleClose()
      }
      return true
    },
    //确认出/入库
    async handleOperateStock(operateDone = false) {
      if (this.formView.isSaleReturn) {
        await this.saveSaleReturn()
        return
      }
      let isAllDone = true
      let index = 1
      for (let row of this.$refs.detailTable.tableData) {
        const quantity = parseInt(row.Quantity) || 0
        const doneQuantity = parseInt(row.DoneQuantity) || 0
        const actualQuantity = parseInt(row.ActualQuantity) || 0
        if (!this.formView.isPurchaseType && actualQuantity <= 0) {
          this.$message.error(`第${index}行${this.formView.stockTypeDesc}数量不能为0`)
          return
        } else if (this.formView.isPurchaseType && quantity - doneQuantity > actualQuantity) {
          isAllDone = false
          break
        }
        index++
      }
      if (!this.stockOrder.ID && !(await this.handleSave(false))) {
        return
      }
      if (!this.stockOrder.ID) {
        this.$message.error(`${this.formView.stockTypeDesc}单不存在`)
        return
      }
      if (this.formView.isPurchaseType && ((!operateDone && isAllDone) || (operateDone && !isAllDone))) {
        const confirmText =
          !operateDone && isAllDone
            ? `本单据所有商品${this.formView.stockTypeDesc}数量都超出${this.formView.purchaseTypeDesc}数量，确认仍按部分${this.formView.stockTypeDesc}处理？`
            : `本单据尚有商品未达${this.formView.purchaseTypeDesc}数量，完成后不可修改，确定完成${this.formView.stockTypeDesc}？`
        this.$baseConfirm(confirmText, null, async () => {
          await this.operateStock(operateDone)
        })
      } else {
        await this.operateStock(operateDone)
      }
    },
    async operateStock(operateDone) {
      const param = {
        ID: this.stockOrder.ID,
        StockType: this.stockOrder.StockType,
        OrderType: this.stockOrder.OrderType,
        StockStatus: operateDone ? 2 : 1,
        DetailList: this.$refs.detailTable.tableData.map(row => ({
          DetailID: row.DetailID,
          ItemNo: row.ItemNo,
          SpecName: row.SpecName,
          ActualQuantity: row.ActualQuantity || 0,
        })),
      }
      this.submitLoading = true
      const { data } = await submit('/api/wms/stock/OperateStock', param)
      this.submitLoading = false
      if (data.errorMsg) {
        this.$message.error(data.errorMsg)
        return
      }
      this.stockOrder.StockStatus = operateDone ? 2 : 1
      this.$message.success('确认成功')
      this.handleClose()
    },
    //销售退货入库
    async saveSaleReturn() {
      if (this.$refs.detailTable.tableData.length <= 0) {
        this.$message.error('退货商品不能为空')
        return
      }
      if (!this.formView.Quantity || this.formView.Quantity <= 0) {
        this.$message.error('退货数量不能为0')
        return
      }
      if (this.formView.Quantity != this.formView.ActualQuantity) {
        this.$message.error('退货数量与待入库数量不符')
        return
      }
      const hasNoMatch = this.$refs.detailTable.tableData.some(row => !row.SpecID)
      if (hasNoMatch) {
        this.$message.error('存在未分配的商品，请分配到具体规格后入库')
        return
      }
      const param = {
        RefundDate: this.returnOrder.returnDate,
        RefundIDs: this.returnOrder.refundIDs,
        SupplierID: this.stockOrder.SupplierID,
        SupplierName: this.stockOrder.SupplierName,
        WID: this.stockOrder.WID,
        WName: this.stockOrder.WName,
        Details: this.$refs.detailTable.tableData.map(row => ({
          ProductID: row.ProductID,
          SpecID: row.SpecID,
          CheckNum: row.ActualQuantity,
        })),
      }
      try {
        this.submitLoading = true
        const res = await submit('/api/wms/stock/saveReturnStockOrder', param)
        if (!res.success) {
          this.$message.error(res.msg ?? '操作失败')
        } else {
          this.$message.success('操作成功')
          this.handleClose()
        }
      } finally {
        this.submitLoading = false
      }
    },
    //扫码处理
    async handleScanBarcode() {
      const barcode = this.scanBarcode?.trim()
      if (!barcode) {
        this.$refs.scanInput?.focus()
        return
      }
      if (this.scanLoading) return
      this.scanLoading = true
      try {
        const res = await submit(`/api/product/getProductSpecByBarcode?barcode=${encodeURIComponent(barcode)}`)
        if (!res.success) {
          this.$message.error(res.msg || '未识别到该条码')
          return
        }
        const spec = res.data
        const tableData = this.$refs.detailTable.tableData
        //新增行的数量：批量设置有值时用批量值，否则默认1；已存在行始终+1
        const initQty = this.batchSetActualQuantity > 0 ? this.batchSetActualQuantity : 1
        //查找同货号同颜色同尺码的行
        const existRow = tableData.find(row => row.ProductID == spec.ProductID && row.Color == spec.Color && row.Size == spec.Size)
        if (existRow) {
          //已存在，数量+1
          existRow.ActualQuantity = (existRow.ActualQuantity || 0) + 1
          this.$refs.detailTable.setRow(tableData.indexOf(existRow))
        } else {
          //新增行，使用批量设置的数量
          const isNewItemNo = !tableData.some(row => row.ProductID == spec.ProductID)
          if (isNewItemNo) {
            this.formView.TotalItemNum += 1
          }
          const newRow = {
            DetailID: 0,
            ID: this.stockOrder.ID,
            ProductID: spec.ProductID,
            ItemNo: spec.ItemNo,
            SpecID: spec.SpecID,
            SpecName: spec.SpecName,
            Color: spec.Color,
            Size: spec.Size,
            Quantity: undefined,
            DoneQuantity: 0,
            ActualQuantity: initQty,
          }
          tableData.push(newRow)
          this.$refs.detailTable.setRow(tableData.length - 1)
        }
        this.formView.ActualQuantity = tableData.reduce((total, item) => total + (item.ActualQuantity || 0), 0)
      } finally {
        this.scanLoading = false
        this.scanBarcode = ''
        this.$nextTick(() => {
          this.$refs.scanInput?.focus()
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .in-out-stock-form {
    .el-drawer__header {
      padding: 10px 8px;
      margin-bottom: 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      border-bottom: 1px solid #dcdfe6;
      margin-bottom: 10px;
    }

    .el-drawer__body {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .el-container {
      flex: 1;
      overflow: hidden;
    }

    .el-header {
      height: auto !important;
      padding: 0 8px;
    }

    .el-form {
      text-align: right;

      .stats {
        float: left;

        .el-form-item__label,
        .el-form-item__content {
          font-size: 16px;
        }

        .return-date,
        .quantity {
          font-size: 20px;
          font-weight: 700;
        }
      }
    }

    .header-action {
      width: 80px;
      margin-left: 5px;
      vertical-align: baseline;
    }

    .wait-match {
      color: red;
      cursor: pointer;
    }

    .match-done {
      color: #a3a3a3;
    }

    .scan-barcode-input {
      .el-input__inner {
        height: 80px;
        font-size: 18px;
        text-align: center;
      }
    }

    .el-icon-delete {
      color: red;
    }

    .el-main {
      overflow: auto;
      flex: 1;
    }

    .el-footer {
      height: auto !important;
      padding: 8px;
      border-top: none;
      text-align: right;
      flex-shrink: 0;
    }
  }
}
</style>
